import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ForgotPassword() {
    const navigate = useNavigate();
    const { forgotPassword, forgotPasswordMobileRequestOtp, forgotPasswordMobileConfirm } = useAuth();

    const [mode, setMode] = useState('email');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [mobileStep, setMobileStep] = useState('phone');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [infoMessage, setInfoMessage] = useState('');

    const handleEmailSubmit = async (event) => {
        event.preventDefault();
        setErrorMessage('');
        setInfoMessage('');

        const normalizedEmail = (email || '').trim();
        if (!normalizedEmail) {
            setErrorMessage('Email is required.');
            return;
        }

        setIsSubmitting(true);
        const result = await forgotPassword({ email: normalizedEmail });
        setIsSubmitting(false);

        if (!result.success) {
            setErrorMessage(result.message || 'Unable to process forgot password request.');
            return;
        }

        setInfoMessage(result?.data?.message || 'If your email is registered, a password reset link has been sent.');
    };

    const handleMobileRequestOtp = async (event) => {
        event.preventDefault();
        setErrorMessage('');
        setInfoMessage('');
        const normalizedPhone = (phone || '').trim();
        if (!normalizedPhone) {
            setErrorMessage('Mobile number is required.');
            return;
        }
        setIsSubmitting(true);
        const result = await forgotPasswordMobileRequestOtp({ phone: normalizedPhone });
        setIsSubmitting(false);
        if (!result.success) {
            setErrorMessage(result.message || 'Unable to send OTP.');
            return;
        }
        setInfoMessage(result?.data?.message || 'If this mobile is registered, an OTP has been sent.');
        setMobileStep('confirm');
    };

    const handleMobileConfirm = async (event) => {
        event.preventDefault();
        setErrorMessage('');
        if (newPassword !== confirmPassword) {
            setErrorMessage('Passwords do not match.');
            return;
        }
        setIsSubmitting(true);
        const result = await forgotPasswordMobileConfirm({
            phone: phone.trim(),
            otp: otp.trim(),
            newPassword,
        });
        setIsSubmitting(false);
        if (!result.success) {
            setErrorMessage(result.message || 'Unable to reset password.');
            return;
        }
        navigate('/login', {
            replace: true,
            state: { message: 'Password reset successful. Please login with your new password.' },
        });
    };

    return (
        <div className="page-content pt-20 pb-20">
            <div className="container">
                <div className="row">
                    <div className="col-xl-8 col-lg-10 col-md-12 m-auto">
                        <div className="row">
                            <div className="col-lg-6 pr-30 d-none d-lg-block">
                                <img className="border-radius-15" src="assets/imgs/page/login-1.png" alt="" />
                            </div>
                            <div className="col-lg-6 col-md-8">
                                <div className="login_wrap widget-taber-content background-white">
                                    <div className="padding_eight_all bg-white">
                                        <div className="heading_s1">
                                            <h1 className="mb-5">Forgot Password</h1>
                                            <p className="mb-20"><Link to="/login">Back to Login</Link></p>
                                            <div className="d-flex gap-2 mb-20">
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm ${mode === 'email' ? 'btn-fill-out' : 'btn-outline-secondary'}`}
                                                    onClick={() => { setMode('email'); setErrorMessage(''); }}
                                                >
                                                    Email link
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm ${mode === 'mobile' ? 'btn-fill-out' : 'btn-outline-secondary'}`}
                                                    onClick={() => { setMode('mobile'); setErrorMessage(''); }}
                                                >
                                                    Mobile OTP
                                                </button>
                                            </div>
                                        </div>
                                        {infoMessage ? <div className="alert alert-info py-2">{infoMessage}</div> : null}
                                        {errorMessage ? <div className="alert alert-danger py-2">{errorMessage}</div> : null}

                                        {mode === 'email' ? (
                                            <form onSubmit={handleEmailSubmit}>
                                                <p className="text-muted small">Use your verified account email.</p>
                                                <div className="form-group">
                                                    <input
                                                        type="email"
                                                        required
                                                        name="email"
                                                        value={email}
                                                        onChange={(event) => setEmail(event.target.value)}
                                                        placeholder="Email"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-heading btn-block hover-up" disabled={isSubmitting}>
                                                        {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                                                    </button>
                                                </div>
                                            </form>
                                        ) : mobileStep === 'phone' ? (
                                            <form onSubmit={handleMobileRequestOtp}>
                                                <p className="text-muted small">Use your verified mobile number.</p>
                                                <div className="form-group">
                                                    <input
                                                        type="tel"
                                                        required
                                                        value={phone}
                                                        onChange={(event) => setPhone(event.target.value)}
                                                        placeholder="Mobile number"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-heading btn-block hover-up" disabled={isSubmitting}>
                                                        {isSubmitting ? 'Sending...' : 'Send OTP'}
                                                    </button>
                                                </div>
                                            </form>
                                        ) : (
                                            <form onSubmit={handleMobileConfirm}>
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        required
                                                        value={otp}
                                                        onChange={(event) => setOtp(event.target.value)}
                                                        placeholder="OTP"
                                                        maxLength={6}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        type="password"
                                                        required
                                                        value={newPassword}
                                                        onChange={(event) => setNewPassword(event.target.value)}
                                                        placeholder="New password"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        type="password"
                                                        required
                                                        value={confirmPassword}
                                                        onChange={(event) => setConfirmPassword(event.target.value)}
                                                        placeholder="Confirm password"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-heading btn-block hover-up" disabled={isSubmitting}>
                                                        {isSubmitting ? 'Saving...' : 'Reset Password'}
                                                    </button>
                                                </div>
                                            </form>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
